module.exports = __webpack_public_path__ + "img/0.b148354d.png";